import { useLocation } from 'react-router-dom';
import { OnscreenApi } from '..//../pages';

export const OnscreenApiWrapper = () => {
  const location = useLocation();

  // Use location.key as key to force remount
  return <OnscreenApi key={location.key} />;
};
